// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!/Users/jliu4/uim-ui-components/node_modules/css-loader/index.js!/Users/jliu4/uim-ui-components/components/ui-widgets/src/style/user-profile.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!/Users/jliu4/uim-ui-components/node_modules/style-loader/addStyles.js")(content);
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	module.hot.accept("!!/Users/jliu4/uim-ui-components/node_modules/css-loader/index.js!/Users/jliu4/uim-ui-components/components/ui-widgets/src/style/user-profile.css", function() {
		var newContent = require("!!/Users/jliu4/uim-ui-components/node_modules/css-loader/index.js!/Users/jliu4/uim-ui-components/components/ui-widgets/src/style/user-profile.css");
		if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
		update(newContent);
	});
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/style/user-profile.css
// module id = 28
// module chunks = 0